import { Path } from '@src/navigations/routes';
import { lazy } from 'react';
import {
  DashboardIcon,
  TransactionsIcon,
  CustomersIcon,
  PaymentLinksIcon,
  SetupGuideIcon,
  ApiKeysIcon
} from '../assets';
import { AsideBlockProps } from '../components/aside/asideBlock';

const Money = lazy(() => import('@sendsprint/ui-react/dist/icons/Money'));

export const receiverMenuData: AsideBlockProps[] = [
  {
    links: [
      {
        to: Path.ReceiverDashboard,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        icon: DashboardIcon as any,
        label: 'Dashboard',
        ComponentToPreloadName: 'Dashboard',
        client: 'receiver'
      },
      {
        label: 'Transactions',
        to: Path.ReceiverTransactions,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        icon: TransactionsIcon as any,
        ComponentToPreloadName: 'Transactions',
        client: 'receiver',
        tourIdentifier: 'transactions'
      },
      {
        icon: Money,
        label: 'Settlements',
        to: Path.ReceiverSettlements,
        ComponentToPreloadName: 'Settlements',
        client: 'receiver'
      },
      {
        label: 'Customers',
        to: Path.ReceiverCustomers,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        icon: CustomersIcon as any,
        ComponentToPreloadName: 'Customers',
        client: 'receiver',
        tourIdentifier: 'customers'
      },
      {
        label: 'Payment links',
        to: Path.ReceiverPaymentLinks,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        icon: PaymentLinksIcon as any,
        ComponentToPreloadName: 'PaymentLinks',
        client: 'receiver',
        tourIdentifier: 'payment-links'
      }
    ]
  }
];

export const senderMenuData: AsideBlockProps[] = [
  {
    links: [
      {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        icon: DashboardIcon as any,
        label: 'Dashboard',
        to: Path.SenderDashboard,
        ComponentToPreloadName: 'DashboardPage',
        client: 'sender'
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        icon: TransactionsIcon as any,
        label: 'Transactions',
        to: Path.SenderTransactions,
        ComponentToPreloadName: 'TransactionsPage',
        client: 'sender',
        tourIdentifier: 'transactions'
      }
    ]
  }
];

export const remittanceMenuData: AsideBlockProps[] = [
  {
    links: [
      {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        icon: SetupGuideIcon as any,
        label: 'Setup Guide',
        to: Path.SenderSetupGuide,
        ComponentToPreloadName: 'SetupGuidePage',
        client: 'sender'
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        icon: DashboardIcon as any,
        label: 'Dashboard',
        to: Path.SenderDashboard,
        ComponentToPreloadName: 'DashboardPage',
        client: 'sender'
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        icon: TransactionsIcon as any,
        label: 'Transactions',
        to: Path.SenderTransactions,
        ComponentToPreloadName: 'TransactionsPage',
        client: 'sender'
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        icon: ApiKeysIcon as any,
        label: 'API keys & webhooks',
        to: Path.SenderApiKeysWebhooks,
        ComponentToPreloadName: 'SetupGuidePage',
        client: 'sender'
      }
    ]
  }
];

export const whiteLabelMenuData: AsideBlockProps[] = [
  {
    sectionHeader: 'WHITE LABEL',
    links: [
      {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        icon: SetupGuideIcon as any,
        label: 'Setup Guide',
        to: Path.WhiteLabelSetup
      }
    ]
  }
];
